export default "__VITE_ASSET__16d62d7c__"